export default __webpack_public_path__ + "static/media/dry_cool_small_2.f2dfee4c.jpg";